module.exports = __webpack_public_path__ + "img/c_rpa.d6f8d59d.jpg";